/**
 * Landing pública de ava-client (ruta `/` sin sesión) — TALAPP-1916.
 *
 * Una sola pantalla sin scroll sobre el gradiente hero: header, hero con la
 * demo del teléfono, "Conocé más" (desktop) y footer. Los textos viven en
 * `landingContent.ts`.
 */
import { LandingFooter } from "@/pages/home/LandingFooter";
import { LandingHeader } from "@/pages/home/LandingHeader";
import { LandingHero } from "@/pages/home/LandingHero";
import { LandingMoreLink } from "@/pages/home/LandingMoreLink";

// Gradiente hero del design system (`ava-hero-gradient`). No se usa HeroPanel:
// envuelve los hijos en un bloque y esta pantalla necesita que header, main y
// footer sean ítems flex para repartir el alto sin scroll.
export function PublicLanding() {
  return (
    <div className="ava-hero-gradient relative flex min-h-dvh flex-col overflow-hidden text-white">
      {/* Las 3 ondas del hero (15/10/8 % de blanco), ancladas abajo y
          estiradas al ancho de la pantalla. */}
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-56 w-full md:h-90"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path className="fill-white/15" d="M0,190 C220,230 430,160 720,190 S1230,240 1440,170 L1440,320 L0,320 Z" />
        <path className="fill-white/10" d="M0,235 C260,200 480,275 720,240 S1200,190 1440,220 L1440,320 L0,320 Z" />
        <path className="fill-white/8" d="M0,275 C300,255 520,300 760,280 S1220,250 1440,268 L1440,320 L0,320 Z" />
      </svg>
      {/* Velo con el azul más oscuro del propio gradiente: el tercio inferior
          (el más claro) no da contraste AA con texto blanco chico. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-85 bg-linear-to-t from-(--ava-blue-900)/65 via-(--ava-blue-900)/40 via-55% to-transparent md:h-95"
      />

      <LandingHeader />
      <main className="relative flex min-h-0 flex-1 flex-col">
        <LandingHero />
        <div className="mx-auto hidden w-full max-w-7xl px-8 pb-3 md:block">
          <LandingMoreLink />
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
